import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21ZM10 11V13H11V17H14V15H13V11H10ZM11 7V9H13V7H11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "InfoSquare"
);
